export const RESOURCES_ENTITY = [
  "entitieslocation",
  "vouchers",
  "giftcards",
  "productsoffered",
  "bogo",
  "discount",
  "cashier",
] as const;
export type ResourceEntityType = (typeof RESOURCES_ENTITY)[number];

export const RESOURCES_ADMIN = ["users", "entities", "vouchers"] as const;
export type ResourceAdminType = (typeof RESOURCES_ADMIN)[number];

export const RESOURCES_CASHIER = ["vouchers"] as const;
export type ResourceCashierType = (typeof RESOURCES_CASHIER)[number];

export const SIDEBAR_WIDTH = 260;
export const COLLAPSED_WIDTH = 0;
export const APP_BAR_HEIGHT = 85;
